
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AssistantStreamEvent": [
      "SessionReady",
      "TurnStarted",
      "MessageDelta",
      "ToolCall",
      "Notice",
      "AssistantMessage",
      "TurnError",
      "TurnDone"
    ],
    "BaseAsset2": [
      "DisplayAsset2",
      "TextAsset2",
      "VideoAsset2"
    ],
    "BaseChange": [
      "MultiValueChange",
      "SingleValueChange"
    ],
    "BaseChangeLogEntry": [
      "ChangeLogEntry",
      "ChangeLogNotificationEntry"
    ],
    "BaseChangeValue": [
      "SimpleChangeValue"
    ],
    "BaseCreativeV5": [
      "AdSelectorSlateCreativeV5",
      "AdSelectorVideoCreativeV5",
      "AuditBaseCreativeV5",
      "BrightlineCreativeV5",
      "DraxCreativeV5",
      "GatewayGoCreativeV5",
      "InnovidCreativeV5",
      "InstreamDxcCreativeV5",
      "MagniteCreativeV5",
      "OutstreamDxcCreativeV5",
      "PauseCreativeV5",
      "SlateCreativeV5",
      "VASTVideoCreativeV5",
      "VideoCreativeV5"
    ],
    "BaseDateRangeV5": [
      "DateRangeV5"
    ],
    "BaseResponseError": [
      "NotificationResponseError",
      "ResponseError"
    ],
    "ChangeLogUnionObject": [
      "CampaignV5",
      "AuditAdV5",
      "AuditLineItemV5",
      "AuditBaseCreativeV5",
      "OrderV5"
    ],
    "Citation": [
      "DocCitation",
      "EntityCitation"
    ],
    "Connection": [
      "AdsPageV5",
      "AgencyPage",
      "Assets2Page",
      "BaseCreativePageV5",
      "BrandsPage",
      "CampaignsPageV5",
      "ChangeLog",
      "ContentPartnerPage",
      "CustomPacingReportListPage",
      "IndustryPage",
      "IngestionTracesPage",
      "LineItemsPageV5",
      "NotificationPage",
      "TargetingPresetPage",
      "TargetingValuePage",
      "TraffickerEmailsPage",
      "TraffickingCustomFiltersConnection",
      "UserPageV4",
      "UserRoleChangeLogPage"
    ],
    "CreateAdsWithCreativesAdEntity": [
      "AdV5",
      "CreateAdsWithCreativesFailedAdEntity"
    ],
    "CreateAdsWithCreativesCreativeEntity": [
      "SlateCreativeV5",
      "VASTVideoCreativeV5",
      "VideoCreativeV5",
      "CreateAdsWithCreativesFailedCreativeEntity"
    ],
    "CreativeTypePropertiesV5": [
      "BrightlineTypePropertiesV5",
      "DisplayTypePropertiesV5",
      "InnovidTypePropertiesV5",
      "PauseTypePropertiesV5",
      "SlateTypePropertiesV5",
      "VASTVideoTypePropertiesV5",
      "VideoTypePropertiesV5"
    ],
    "CustomPacingMetricsBase": [
      "LineItemMetrics",
      "SummaryMetrics"
    ],
    "DateOperatorFields": [
      "DateOperatorFilter",
      "LineItemEndDateFilter"
    ],
    "DropdownOptionFilter": [
      "AgencyDropdownOptionFilter",
      "BrandDropdownOptionFilter",
      "IndustryDropdownOptionFilter"
    ],
    "DxcCreativeV5": [
      "InstreamDxcCreativeV5",
      "OutstreamDxcCreativeV5"
    ],
    "DxcExecutable": [
      "EmailUmpDxcExecutable",
      "KervDxcExecutable",
      "PushUmpDxcExecutable",
      "QrDxcExecutable"
    ],
    "Edge": [
      "AdEdgeV5",
      "AgencyEdge",
      "Assets2Edge",
      "BaseCreativeEdgeV5",
      "BrandEdge",
      "CampaignEdgeV5",
      "ChangeLogEntryEdge",
      "ContentPartnerEdge",
      "CustomPacingReportListEdge",
      "IndustryEdge",
      "IngestionTraceEdge",
      "LineItemEdgeV5",
      "NotificationEdge",
      "TargetingPresetEdge",
      "TargetingValueEdge",
      "TraffickerEmailEdge",
      "TraffickingCustomFilterEdge",
      "UserEdgeV4",
      "UserRoleChangeLogEdge"
    ],
    "LineItemV5Body": [
      "AuditLineItemV5",
      "LineItemV5"
    ],
    "Node": [
      "AdSelectorSlateCreativeV5",
      "AdSelectorVideoCreativeV5",
      "AdV5",
      "Agency",
      "Asset2CampaignGQLView",
      "Asset2Tag",
      "AuditBaseCreativeV5",
      "BaseTargetingValue",
      "Brand",
      "BrightlineCreativeV5",
      "CampaignV5",
      "ChangeLogNode",
      "ContentPartner",
      "CustomFilter",
      "CustomPacingReport",
      "CustomerBrand",
      "DisplayAsset2",
      "DraxCreativeV5",
      "GatewayGoCreativeV5",
      "Industry",
      "IngestionTrace",
      "InnovidCreativeV5",
      "InstreamDxcCreativeV5",
      "LineItemV5",
      "MagniteCreativeV5",
      "Notification",
      "OutstreamDxcCreativeV5",
      "PauseCreativeV5",
      "SlateCreativeV5",
      "TargetingPreset",
      "TargetingValue",
      "TextAsset2",
      "TraffickerEmail",
      "TraffickingCustomFilter",
      "UserRoleChangeLogGroup",
      "UserV4",
      "VASTVideoCreativeV5",
      "VideoAsset2",
      "VideoCreativeV5"
    ],
    "PacingMetricsBase": [
      "PacingMetrics",
      "WindowPacingMetrics"
    ],
    "ProgrammaticDeal": [
      "DraxDealV5",
      "MagniteDealV5"
    ],
    "TargetingTermValueBody": [
      "TargetingTermValue",
      "TargetingTermWithBaseValue"
    ],
    "TargetingValueBody": [
      "BaseTargetingValue",
      "TargetingValue"
    ],
    "UmpDxcExecutable": [
      "EmailUmpDxcExecutable",
      "PushUmpDxcExecutable"
    ],
    "VerifiedEntry": [
      "AdV5",
      "AdTag"
    ]
  }
};
      export default result;
    